export default "__VITE_ASSET__C8sRDsMJ__"